import type { AllRouteEndpoints } from "../routeTypes";
export const supportCasesAppGroupIdCacheKeys: AllRouteEndpoints[] = [];
